import { Skeleton } from '@sib/ui';

export const InviteesListSkeleton = () => {
  const SKELETON_ITEMS = 3;

  return (
    <ul className="max-h-[250px] overflow-y-auto">
      {Array.from({ length: SKELETON_ITEMS }).map((_, index) => (
        <li
          key={index}
          className="border-border flex items-center justify-between border-b px-3.5 py-2 last:border-none"
        >
          <div className="flex items-center gap-6">
            <Skeleton className="size-11 rounded-full" />
            <div className="flex flex-col gap-1">
              <Skeleton className="h-4 w-20 rounded-sm" />
              <Skeleton className="h-4 w-50 rounded-sm" />
            </div>
          </div>
          <Skeleton className="h-9 w-20 rounded-sm" />
        </li>
      ))}
    </ul>
  );
};
